import React, { PureComponent } from 'react';

class NoResults extends PureComponent {
    render() {
        const { classes } = this.props;

        return (
            <div className={['noresults-container', classes && classes].join(' ')}>
                <h1 key={0}>Sorry, we can’t find any matches.</h1>
                <p key={1}>Try changing your filters or increasing the search distance. Need more help? <a href="https://www.livewelldorset.co.uk/contact/">Contact Us</a>.</p>
            </div>  
        );
    }
}

export default NoResults;
